{
	"success": {
		"title": "Pagamento confirmado",
		"message": "Seu pagamento foi processado com sucesso. Você já pode fechar esta página."
	},
	"pending": {
		"title": "Pagamento em processamento",
		"message": "Estamos confirmando seu pagamento. Isso pode levar alguns instantes."
	},
	"failed": {
		"title": "Pagamento não concluído",
		"message": "Não foi possível processar seu pagamento. Tente novamente ou use outro método."
	},
	"canceled": {
		"title": "Pagamento cancelado",
		"message": "O pagamento foi cancelado."
	},
	"unknown": {
		"title": "Status indisponível",
		"message": "Não conseguimos identificar o status do seu pagamento."
	}
}
